const PanelContainer = {
  baseStyle: {
    p: { base: "8px 4px", sm: "12px 6px", md: "16px 12px", xl: "20px 16px" },
    minHeight: "calc(100vh - 123px)",
    w: "100%",
    maxWidth: "100%",
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
